// Email attachments: 9 MB is the enforced cap; the user-facing copy intentionally
// states 10 MB as a conservative buffer. Keep both here so they can't silently diverge.
export const MAX_ATTACHMENT_BYTES = 9 * 1024 * 1024;
export const ATTACHMENT_OVER_LIMIT_MESSAGE = 'Attachments exceed 10 MB. Remove a file to send.';
